<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.value"
      :key="option.value"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterDealProbabilityScore",
  props: {
    label: {
      type: String,
      default: "Deal Probability Score"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].dealProbabilityScore;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "dealProbabilityScore",
          value
        ]);
      }
    },
    options() {
      return [
        { value: null, label: 'All scores' },
        ...this.$store.state.enums.dealProbabilityScoreEnum
      ];
    },
    text() {
      if (this.filterValue !== '') {
        let dealProbability = this.$store.state.enums.dealProbabilityScoreEnum.find(probability => probability.value === this.filterValue);
        return dealProbability ? dealProbability.label + " Deal Probability" : null;
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
}
</script>
